import { authFetch } from "~/services/fetch";
import { CategoryResponse } from "../interface";

export async function getAllCategories(): Promise<readonly CategoryResponse[]> {
  try {
    const { data } = await authFetch({
      url: '/category',
      method: 'GET',
    })
    return data;
  } catch (error) {
    throw error;
  }
}